import { render, staticRenderFns } from "./masteRecordDetail.vue?vue&type=template&id=778ec14a&"
import script from "./masteRecordDetail.vue?vue&type=script&lang=js&"
export * from "./masteRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./masteRecordDetail.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports